import React from 'react';

import { FormInstance } from 'antd';
import {
  InputNumber,
  Collapse,
} from 'UI';

import {
  FormContainer,
  BaseFormItem,
  ToggledCollapse,
} from './style';

export interface AddProductFormData {
  periodFormation?: number
  periodGermination?: number
  periodGrafting?: number
  periodHealing?: number
  loss?: number
}

interface AddProductFormProps {
  formHandler: FormInstance
  onSubmit(data: unknown): void
  isLoading?: boolean
  isGrafting?: boolean
  isActive: boolean
  productData?: AddProductFormData
}

const AddProductForm = ({
  formHandler,
  onSubmit,
  isLoading,
  isGrafting,
  isActive,
  productData,
}: AddProductFormProps): JSX.Element => (
  <ToggledCollapse activeKey={isActive ? 'productCollapse' : ''} ghost>
    <Collapse.Panel key="productCollapse" header={null}>
      <FormContainer
        layout="vertical"
        form={formHandler}
        requiredMark={false}
        onFinish={onSubmit as (val: unknown) => void}
      >
        <BaseFormItem
          label="Tempo de formação (dias)"
          name="periodFormation"
          initialValue={productData?.periodFormation}
          rules={[
            {
              required: isActive,
              message: 'Preencha um tempo de formação',
            },
          ]}
        >
          <InputNumber disabled={isLoading} />
        </BaseFormItem>
        <BaseFormItem
          label="Tempo de germinação (dias)"
          name="periodGermination"
          initialValue={productData?.periodGermination}
          rules={[
            {
              required: isActive,
              message: 'Preencha um tempo de germinação',
            },
          ]}
        >
          <InputNumber disabled={isLoading} />
        </BaseFormItem>
        {isGrafting && (
          <>
            <BaseFormItem
              label="Tempo de enxertia (dias)"
              name="periodGrafting"
              initialValue={productData?.periodGrafting}
              rules={[
                {
                  required: isActive,
                  message: 'Preencha um tempo de enxertia',
                },
              ]}
            >
              <InputNumber disabled={isLoading} />
            </BaseFormItem>
            <BaseFormItem
              label="Tempo de cicatrização (dias)"
              name="periodHealing"
              initialValue={productData?.periodHealing}
              rules={[
                {
                  required: isActive,
                  message: 'Preencha um tempo de cicatrização',
                },
              ]}
            >
              <InputNumber disabled={isLoading} />
            </BaseFormItem>
          </>
        )}
        <BaseFormItem
          label="Perda (%)"
          name="loss"
          initialValue={((productData?.loss || 0) * 100).toFixed(0)}
          rules={[
            {
              required: isActive,
              message: 'Preencha uma porcentagem de perda',
            },
          ]}
        >
          <InputNumber min={0} max={100} disabled={isLoading} />
        </BaseFormItem>
      </FormContainer>
    </Collapse.Panel>
  </ToggledCollapse>
);

AddProductForm.defaultProps = {
  isLoading: false,
  isGrafting: false,
  productData: undefined,
};

export default AddProductForm;
